import clsx from 'clsx';
import { FormattedMessage, useIntl } from 'react-intl';

import { useForwardAccumulatorSelector } from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { getForwardAccumulatorMarketData } from '@/store/forwardAccumulator/selectors.ts';

const Volatility = () => {
  const { formatNumber } = useIntl();
  const marketData = useForwardAccumulatorSelector((accumulator) => getForwardAccumulatorMarketData(accumulator));
  const isExpired = useForwardAccumulatorSelector((accumulator) => accumulator.properties.rfs.status === 'EXPIRED');

  return (
    <div className={clsx('form-group form-group-sm d-flex my-1 no-gutters', { expired: isExpired })}>
      <div className="pe-1 col-form-label col-form-label-sm col-4 text-nowrap text-end" style={{ width: '30%' }}>
        <FormattedMessage id="option.fields.volatility" />
      </div>
      <span className="col-7 fs-6" data-e2e="volatility">
        {marketData?.volatility &&
          formatNumber(marketData?.volatility, { maximumFractionDigits: 3, minimumFractionDigits: 3 })}
      </span>
    </div>
  );
};

export default Volatility;
